export const OAUTH_ERROR_CODES = {
  OAUTH_STATE_MISMATCH_OR_EXPIRED: 'OAUTH_STATE_MISMATCH_OR_EXPIRED',
} as const

type OauthErrorCode = (typeof OAUTH_ERROR_CODES)[keyof typeof OAUTH_ERROR_CODES]

export class OauthError extends Error {
  public readonly code: OauthErrorCode
  public constructor(code: OauthErrorCode, options: ErrorOptions = {}) {
    super(code, options)
    this.code = code
    this.name = 'OauthError'
  }
}
